import React, { lazy } from 'react';
import { PieChart2Line } from '@datanomik/core-ui/icons';

const CashFlowsMainPage = lazy(() =>
  import('./pages/CashFlowsMainPage').then((m) => ({ default: m.CashFlowsMainPage })),
);

export const getCashFlowsV2Routes = () => [
  {
    path: '',
    key: 'cash-flows',
    label: 'Cash flow',
    element: <CashFlowsMainPage />,
    icon: <PieChart2Line />,
  },
];
